import cabinetBeadedThumbnail from 'src/assets/img/homeownerApp/materialCategories/CabinetBeaded.webp';
import cabinetFlatPanelThumbnail from 'src/assets/img/homeownerApp/materialCategories/CabinetFlatPanel.webp';
import cabinetInsetPanelThumbnail from 'src/assets/img/homeownerApp/materialCategories/CabinetInsetPanel.webp';
import cabinetMissionStyleThumbnail from 'src/assets/img/homeownerApp/materialCategories/CabinetMission.webp';
import cabinetRaisedPanelThumbnail from 'src/assets/img/homeownerApp/materialCategories/CabinetRaisedPanel.webp';
import cabinetSkinnyShakerThumbnail from 'src/assets/img/homeownerApp/materialCategories/CabinetSkinnyShaker.webp';
import cabinetWideShakerThumbnail from 'src/assets/img/homeownerApp/materialCategories/CabinetWideShaker.webp';
import claddingBoardAndBattenThumbnail from 'src/assets/img/homeownerApp/materialCategories/CladdingBoardAndBatten.jpeg';
import claddingBrickThumbnail from 'src/assets/img/homeownerApp/materialCategories/CladdingBrick.jpeg';
import claddingHorizontalLapThumbnail from 'src/assets/img/homeownerApp/materialCategories/CladdingHorizontalLap.jpeg';
import claddingShingleThumbnail from 'src/assets/img/homeownerApp/materialCategories/CladdingShingle.jpeg';
import claddingStoneThumbnail from 'src/assets/img/homeownerApp/materialCategories/CladdingStone.jpeg';
import claddingStuccoThumbnail from 'src/assets/img/homeownerApp/materialCategories/CladdingStucco.jpeg';
import floorCarpetThumbnail from 'src/assets/img/homeownerApp/materialCategories/FloorCarpet.jpeg';
import floorStoneThumbnail from 'src/assets/img/homeownerApp/materialCategories/FloorStone.jpeg';
import floorTileThumbnail from 'src/assets/img/homeownerApp/materialCategories/FloorTile.jpeg';
import floorWoodThumbnail from 'src/assets/img/homeownerApp/materialCategories/FloorWood.jpeg';
import garageCarriageStyleThumbnail from 'src/assets/img/homeownerApp/materialCategories/GarageCarriageThumbnail.webp';
import garageModernStyleThumbnail from 'src/assets/img/homeownerApp/materialCategories/GarageModernThumbnail.webp';
import garageTraditionalStyleThumbnail from 'src/assets/img/homeownerApp/materialCategories/GarageTraditionalThumbnail.webp';
import roofMetalThumbnail from 'src/assets/img/homeownerApp/materialCategories/RoofMetal.jpeg';
import roofShingleThumbnail from 'src/assets/img/homeownerApp/materialCategories/RoofShingle.jpeg';
import roofSlateThumbnail from 'src/assets/img/homeownerApp/materialCategories/RoofSlate.jpeg';
import roofTileThumbnail from 'src/assets/img/homeownerApp/materialCategories/RoofTile.jpeg';
import windowDiamondGridThumbnail from 'src/assets/img/homeownerApp/materialCategories/WindowDiamondGrid.webp';
import windowDoubleHungThumbnail from 'src/assets/img/homeownerApp/materialCategories/WindowDoubleHung.webp';
import windowHighCrossGridThumbnail from 'src/assets/img/homeownerApp/materialCategories/WindowHighCrossGrid.webp';
import windowMidCrossGridThumbnail from 'src/assets/img/homeownerApp/materialCategories/WindowMidCrossGrid.webp';
import windowNewEnglandGridThumbnail from 'src/assets/img/homeownerApp/materialCategories/WindowNewEnglandGrid.webp';
import windowPictureThumbnail from 'src/assets/img/homeownerApp/materialCategories/WindowPicture.webp';
import windowPrairieStyleGrid from 'src/assets/img/homeownerApp/materialCategories/WindowPrairieStyleGrid.webp';
import windowTopRowGridThumbnail from 'src/assets/img/homeownerApp/materialCategories/WindowTopRowGrid.webp';
import windowTraditionalStyleGridThumbnail from 'src/assets/img/homeownerApp/materialCategories/WindowTraditionalGridStyle.webp';

/**
 * Palette thumbnail images for default material products. We currently use a
 * simple string match on the palette name to determine which thumbnail to use.
 *
 * @remarks originally, this corresponded to the values in hyperion
 * AiPrompt::PALETTES, but these products are now populated from Product
 * Catalog. Any palette names that don't have a corresponding thumbnail in these
 * defaults or in the partner-specific thumbnail configuration will show a
 * placeholder state.
 *
 * @see {@link https://github.com/hoverinc/hyperion/blob/a7bb082caf17f845d162a61c326fdbf3b2477797/app/models/ai_prompt.rb#L46-L98}
 */
export const DEFAULT_MATERIAL_PALETTE_THUMNBAILS = {
  floor: {
    Hardwood: floorWoodThumbnail,
    Wood: floorWoodThumbnail,
    Stone: floorStoneThumbnail,
    Carpet: floorCarpetThumbnail,
    Tile: floorTileThumbnail,
  },
  roof: {
    Shingle: roofShingleThumbnail,
    'Asphalt Shingle': roofShingleThumbnail,
    Metal: roofMetalThumbnail,
    Tile: roofTileThumbnail,
    Slate: roofSlateThumbnail,
  },
  walls: {
    'Board and Batten': claddingBoardAndBattenThumbnail,
    'Horizontal Lap': claddingHorizontalLapThumbnail,
    'Straight Shingle': claddingShingleThumbnail,
    Brick: claddingBrickThumbnail,
    Stone: claddingStoneThumbnail,
    Stucco: claddingStuccoThumbnail,
  },
  windows: {
    Picture: windowPictureThumbnail,
    'Double Hung': windowDoubleHungThumbnail,
    'Mid-cross Grid': windowMidCrossGridThumbnail,
    'High-cross Grid': windowHighCrossGridThumbnail,
    'Traditional Style': windowTraditionalStyleGridThumbnail,
    'Prairie Style': windowPrairieStyleGrid,
    'Top Row Grid': windowTopRowGridThumbnail,
    'New England': windowNewEnglandGridThumbnail,
    Diamond: windowDiamondGridThumbnail,
  },
  cabinet: {
    'Wide Shaker': cabinetWideShakerThumbnail,
    'Skinny Shaker': cabinetSkinnyShakerThumbnail,
    'Flat Panel': cabinetFlatPanelThumbnail,
    'Mission Style': cabinetMissionStyleThumbnail,
    'Inset Panel': cabinetInsetPanelThumbnail,
    'Raised Panel': cabinetRaisedPanelThumbnail,
    Beaded: cabinetBeadedThumbnail,
  },
  garage_door: {
    Traditional: garageTraditionalStyleThumbnail,
    Carriage: garageCarriageStyleThumbnail,
    Modern: garageModernStyleThumbnail,
  },
};

export type DefaultThumbnails = typeof DEFAULT_MATERIAL_PALETTE_THUMNBAILS;
export type DefaultThumbnailRegion = keyof DefaultThumbnails;
